module.exports = __webpack_public_path__ + "static/media/CrossIcon.75aa5ce9.svg";